import { CircularProgress, MenuItem, Select } from "@mui/material";
import { useAppDispatch, useTrading } from "features/store";
import { useListStrategyGroupsQuery } from "features/trading/accounts";
import { setCurrentStrategyGroup } from "features/trading/tradingSlice";
import { getLastStrategyGroupId } from "helpers";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const StrategyGroupPicker = () => {
  const { currentStrategyGroupId } = useTrading();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  // Check if URL params are present - if so, don't auto-select
  const hasUrlParams = useMemo(
    () =>
      !!searchParams.get("strategy_id") &&
      !!searchParams.get("strategy_group_id"),
    [searchParams],
  );

  const { data, isLoading } = useListStrategyGroupsQuery({
    pagination: { page: 0, pageSize: 100 },
  });

  useEffect(() => {
    // Skip auto-selection if URL params are present (URL strategy hook handles it)
    if (hasUrlParams) return;

    if (data && data.results.length > 0) {
      const lastGroupId = getLastStrategyGroupId();
      const groupId =
        currentStrategyGroupId ||
        data.results.find((group) => group.id === lastGroupId)?.id ||
        data.results[0].id;
      dispatch(setCurrentStrategyGroup(groupId));
    }
  }, [
    data,
    currentStrategyGroupId,
    dispatch,
    setCurrentStrategyGroup,
    hasUrlParams,
  ]);

  return data ? (
    <Select
      labelId="account-label"
      label="Account"
      size="small"
      value={currentStrategyGroupId ? currentStrategyGroupId : ""}
      sx={{ width: 250, borderRadius: 5 }}
      onChange={(event) => {
        dispatch(setCurrentStrategyGroup(event.target.value));
      }}
    >
      {data.results.map((group) => (
        <MenuItem key={group.id} value={group.id}>
          {group.name}
        </MenuItem>
      ))}
    </Select>
  ) : (
    <CircularProgress />
  );
};
